// extracted by mini-css-extract-plugin
export default {"cls1":"RemovedItemNotice-cls1___9bb4d5a3c5f858332f6","cls2":"RemovedItemNotice-cls2___c8714cf47131125c1f9 RemovedItemNotice-cls1___9bb4d5a3c5f858332f6"};